export const rssAlreadyExistsTooltipContent = (type: string) => (
  <>
    <div className="add-skills-self-assessment-action__tooltip-note">
      {type} self-assessment isn&apos;t available,
    </div>
    <div className="add-skills-self-assessment-action__tooltip-note">
      because it already exists.
    </div>
  </>
);

export const rssNotAvailableTooltipContent = (type: string) => (
  <>
    <div className="add-skills-self-assessment-action__tooltip-note">
      {type} self-assessment isn&apos;t available,
    </div>
    <div className="add-skills-self-assessment-action__tooltip-note">
      because no matching skills exist in the
    </div>
    <div className="add-skills-self-assessment-action__tooltip-note">
      skills profile.
    </div>
  </>
);
